/// <amd-module name="Feed/Core/Components/DeletedFeedPanel" />
import * as React from "react";
import { connect } from "react-redux";
import { DynamicModuleLoader } from "redux-dynamic-modules";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";

import { Button } from "VSSUI/Button";

import * as PackageResources from "Feed/Common/Resources";
import { FeedHubActions, getFeedHubModules, IFeedHubViewAwareState } from "Feed/Core/Redux/FeedHub";
import * as FeedHubSelector from "Feed/Core/Redux/FeedHub/FeedHubSelectors";

export interface IDeletedFeedPanelProps {
    feedId?: string;
}

const Actions = {
    showFeedSettings: FeedHubActions.showFeedSettings
};

class UnconnectedDeletedFeedPanel extends VssComponent<IDeletedFeedPanelProps & typeof Actions> {
    private imagePath: string;
    public constructor(props: IDeletedFeedPanelProps & typeof Actions, context?: IVssComponentContext) {
        super(props, context);
        this.imagePath = context ? getAssetLocation(context.pageContext, "ms.feed/feed-core/Content/deleted-feed.svg") : "";
    }
    public render() {
        const { showFeedSettings } = this.props;
        return (
            <div className="deleted-feed-panel">
                <img className="deleted-feed-panel-image" src={this.imagePath} alt={""} />
                <div className="deleted-feed-panel-primary-text">
                    <p>{PackageResources.DeletedFeedPanel_Message}</p>
                </div>
                <div className="deleted-feed-panel-secondary-text">
                    <p>{PackageResources.DeletedFeedPanel_Secondary_Message}</p>
                </div>
                <Button
                    iconProps={{ iconName: "Settings" }}
                    primary={true}
                    onClick={showFeedSettings}
                    text={PackageResources.FeedSettings_ButtonText}
                    className="feed-settings-button"
                />
            </div>
        );
    }
}

function mapStateToProps(state: IFeedHubViewAwareState): IDeletedFeedPanelProps {
    return {
        feedId: FeedHubSelector.getSelectedFeedId(state)
    };
}

const ConnectedDeletedFeedPanel = connect(mapStateToProps, Actions)(UnconnectedDeletedFeedPanel);

export const DeletedFeedPanel = () => (
    <DynamicModuleLoader modules={getFeedHubModules()}>
        <ConnectedDeletedFeedPanel />
    </DynamicModuleLoader>
);
